module.exports = __webpack_public_path__ + "static/media/lenovegroup.fd4edf75.png";